export class ArchiveReason {
  constructor() {
    this.id = "";
    this.name = "";
    this.type = "";
    this.createdBy = "";
  }
}
